module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "in_mobile"
  }, [_c('div', {
    staticClass: "brand inline d-none d-lg-block d-xl-block"
  }, [(_vm.company_logo != '' && _vm.company_logo_exist == 1) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard.index'
      }
    }
  }, [_c('img', {
    staticClass: "logo_c",
    attrs: {
      "src": _vm.company_logo,
      "alt": "logo",
      "data-src": _vm.company_logo
    },
    on: {
      "error": _vm.handleLogoError
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.company_logo == '' && _vm.company_logo_exist == 0) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard.index'
      }
    }
  }, [_c('img', {
    staticClass: "logo_w",
    attrs: {
      "src": "/static/img/logo.svg",
      "alt": "logo",
      "data-src": "/static/img/logo.svg"
    }
  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.liveOrDemoStatus) ? _c('div', {
    staticClass: "mode_alert m-auto"
  }, [_vm._v("\n      Your account is in DEMO mode. To activate LIVE mode please contact your\n      customer success manager.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [(_vm.showOrNot === 2) ? _c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('div', {
    staticClass: "form-check form-check-inline success radioborder mr-2",
    class: {
      active: _vm.liveOrDemo == 'demo'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.liveOrDemo),
      expression: "liveOrDemo"
    }],
    attrs: {
      "type": "radio",
      "name": "state",
      "id": "demo",
      "value": "demo"
    },
    domProps: {
      "checked": _vm._q(_vm.liveOrDemo, "demo")
    },
    on: {
      "change": [function($event) {
        _vm.liveOrDemo = "demo"
      }, _vm.showLiveOrDemo]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "m-0",
    attrs: {
      "for": "demo"
    }
  }, [_vm._v("Demo")])]), _vm._v("\n         \n        "), _c('div', {
    staticClass: "form-check form-check-inline success radioborder mr-3",
    class: {
      active: _vm.liveOrDemo == 'live'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.liveOrDemo),
      expression: "liveOrDemo"
    }],
    attrs: {
      "type": "radio",
      "name": "state",
      "id": "live",
      "value": "live"
    },
    domProps: {
      "checked": _vm._q(_vm.liveOrDemo, "live")
    },
    on: {
      "change": [function($event) {
        _vm.liveOrDemo = "live"
      }, _vm.showLiveOrDemo]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "m-0",
    attrs: {
      "for": "live"
    }
  }, [_vm._v("Live")])])]) : _vm._e(), _vm._v(" "), (this.currentURL == '/') ? _c('span', {
    staticClass: "header_icon btn-icon-link",
    attrs: {
      "title": "Quick Start Guide",
      "data-target": "#quickviewa",
      "data-toggle": "modal"
    }
  }, [_c('i', {
    staticClass: "fas fa-rocket"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "header_icon btn-icon-link",
    attrs: {
      "id": "intro_siderbar",
      "title": "Home screen menus walkthrough."
    },
    on: {
      "click": _vm.startWalkthrough
    }
  }, [_c('i', {
    staticClass: "fas fa-running",
    attrs: {
      "data-placement": "bottom",
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), (!_vm.isHelpIconHidden(_vm.$route.path)) ? _c('span', {
    staticClass: "header_icon btn-icon-link",
    attrs: {
      "id": "faq-btn",
      "data-target": "#help",
      "data-toggle": "modal",
      "data-step": "10",
      "data-intro": "Click here at any page to get your FAQs answered.",
      "data-position": "bottom",
      "title": "Contextual Help & FAQs."
    }
  }, [_c('i', {
    staticClass: "far fa-question-circle"
  })]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('system-alert-bell'), _vm._v(" "), _c('div', {
    staticClass: "dropdown pull-right d-lg-block"
  }, [_c('button', {
    staticClass: "profile-dropdown-toggle logindetail_p",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false",
      "aria-label": "profile dropdown"
    }
  }, [(_vm.currentUser) ? _c('div', {
    staticClass: "logindetail"
  }, [_c('span', [_vm._v("\n              " + _vm._s(_vm.titleCase(_vm.currentUser.first_name)) + "\n              "), (_vm.currentUser.last_name) ? _c('strong', [_vm._v("\n                " + _vm._s(_vm.titleCase(_vm.currentUser.last_name)) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.currentUser.company) + ")")])]) : _vm._e(), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right profile-dropdown",
    attrs: {
      "role": "menu"
    }
  }, [(_vm.permissions.general) ? _c('li', [_c('router-link', {
    staticClass: "m-t-10",
    attrs: {
      "to": {
        name: 'general'
      }
    }
  }, [_c('i', {
    staticClass: "pg-settings_small"
  }), _vm._v(" Settings\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.status && _vm.status == 2 && _vm.company_id != _vm.selected_company) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.updateAdminLogin
    }
  }, [_c('i', {
    staticClass: "pg-outdent"
  }), _vm._v(" Login As Admin")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "bg-master-lighter",
    on: {
      "click": _vm.logoutUser
    }
  }, [_vm._m(3)])])])], 1)]), _vm._v(" "), (
    _vm.managementReportQuickBtnpermissions.vulnerability_trend_new ||
    _vm.managementReportQuickBtnpermissions.awareness_trend_new ||
    _vm.managementReportQuickBtnpermissions.reporting_trend_new ||
    _vm.managementReportQuickBtnpermissions.weakest_links_new ||
    _vm.managementReportQuickBtnpermissions.strongest_links_least_compromised_new ||
    _vm.managementReportQuickBtnpermissions.strongest_links_most_compromised_new ||
    _vm.managementReportQuickBtnpermissions.weakest_departments_new
  ) ? _c('div', {
    class: _vm.quickmenu + ' quickview-wrapper builder hidden-sm hidden-xs',
    attrs: {
      "id": "builder"
    }
  }, [_c('a', {
    staticClass: "builder-close",
    attrs: {
      "data-toggle": "quickview",
      "data-toggle-element": "#builder"
    },
    on: {
      "click": function($event) {
        _vm.quickview()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-times"
  })]), _vm._v(" "), _c('a', {
    staticClass: "builder-toggle",
    attrs: {
      "id": "quickview-btn",
      "data-intro": "Management Level Reporting of your data. Get easy answers.",
      "data-position": "left",
      "data-toggle": "quickview",
      "data-toggle-element": "#builder",
      "title": "Management Report"
    },
    on: {
      "click": function($event) {
        _vm.quickview()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-file-pdf"
  })]), _vm._v(" "), _c('h4', {
    staticClass: "filters_h_tag"
  }, [_vm._v("Management Report")]), _vm._v(" "), _c('div', {
    staticClass: "filter_slide_popup"
  }, [_c('ol', {
    staticClass: "report_link_list"
  }, [(_vm.managementReportQuickBtnpermissions.vulnerability_trend_new) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.phishingvulnerabilitytrend'
      }
    }
  }, [_c('a', {
    class: {
      active:
        _vm.currentRouteName ==
        'managementreport.phishingvulnerabilitytrend',
    }
  }, [_vm._v("\n            What does our Phishing Vulnerability trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.awareness_trend_new) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.cybersecurityawarenesstrend'
      }
    }
  }, [_c('a', {
    class: {
      active:
        _vm.currentRouteName ==
        'managementreport.cybersecurityawarenesstrend',
    }
  }, [_vm._v("What does our Awareness Trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.reporting_trend_new) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.phishingreportingtrend'
      }
    }
  }, [_c('a', {
    class: {
      active:
        _vm.currentRouteName == 'managementreport.phishingreportingtrend',
    }
  }, [_vm._v("What does our Reporting trend look like?")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.weakest_links_new) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.weakestlinks'
      }
    }
  }, [_c('a', {
    class: {
      active: _vm.currentRouteName == 'managementreport.weakestlinks',
    }
  }, [_vm._v("Who are our weakest links?")])]) : _vm._e(), _vm._v(" "), (
    _vm.managementReportQuickBtnpermissions.strongest_links_least_compromised_new
  ) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.strongestlinks-least-compromised'
      }
    }
  }, [_c('a', {
    class: {
      active:
        _vm.currentRouteName ==
        'managementreport.strongestlinks-least-compromised',
    }
  }, [_vm._v("Who are our strongest links? (Least Compromised)")])]) : _vm._e(), _vm._v(" "), (
    _vm.managementReportQuickBtnpermissions.strongest_links_most_compromised_new
  ) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.strongestlinks-most-reported'
      }
    }
  }, [_c('a', {
    class: {
      active: _vm.currentRouteName == 'strongestlinks-most-reported',
    }
  }, [_vm._v("Who are our strongest links? (Most Reported)")])]) : _vm._e(), _vm._v(" "), (_vm.managementReportQuickBtnpermissions.weakest_departments_new) ? _c('router-link', {
    attrs: {
      "tag": "li",
      "to": {
        name: 'managementreport.weakestdepartments'
      }
    }
  }, [_c('a', {
    class: {
      active:
        _vm.currentRouteName == 'managementreport.weakestdepartments',
    }
  }, [_vm._v("Which of our departments are the weakest?")])]) : _vm._e()], 1)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "hamburger"
  }, [_c('i', {
    staticClass: "fas fa-bars"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "theme_change btn-icon-link",
    staticStyle: {
      "display": "none"
    }
  }, [_c('i', {
    staticClass: "fas fa-sun"
  }), _c('i', {
    staticClass: "far fa-moon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "thumbnail-wrapper d32 circular inline"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/dummy_user.png",
      "alt": "",
      "data-src": "/static/img/dummy_user.png",
      "width": "32",
      "height": "32"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "clearfix pointer"
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("Logout")]), _vm._v(" "), _c('span', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "pg-power",
    staticStyle: {
      "padding": "11px"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a8818c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/root/navbar.vue
// module id = 1435
// module chunks = 32